import { IActionType } from '@makyoapp/makyo-common'

// Node and edge styling constants
export const NODE_STYLES = {
  handle: {
    target: 'w-3 h-3 bg-white border-2 border-gray-300 rounded-full shadow-sm hover:border-gray-400',
    source:
      'min-w-4! min-h-4! bg-gray-400! dark:bg-slate-500! rounded-full! cursor-pointer dark:hover:bg-slate-400 border-none! z-10 hover:bg-teal-500! hover:border-teal-500! hover:border-2!',
  },
  edge: {
    default: { stroke: '#9ca3af', strokeWidth: 2 },
    hovered: { stroke: '#14b8a6', strokeWidth: 2 },
  },
  edgeControls: {
    addButton:
      'w-7 h-7 bg-teal-100 text-gray-700 rounded-sm flex items-center justify-center shadow-lg hover:bg-teal-100 transition-colors text-xs nodrag nopan border border-gray-300 cursor-pointer',
    deleteButton:
      'w-7 h-7 bg-red-100 text-gray-700 rounded-sm flex items-center justify-center shadow-lg hover:bg-red-100 transition-colors text-xs nodrag nopan border border-gray-300 cursor-pointer',
  },
}

// Layout constants
export const LAYOUT = {
  nodeSpacing: 250,
  nodeYPosition: 100,
  edgeHoverWidth: 50,
}

// Special node IDs
export const SPECIAL_NODES = {
  trigger: 'trigger-node',
}

// React Flow configuration
export const REACT_FLOW_CONFIG = {
  fitViewOptions: {
    padding: 0.8,
    minZoom: 0.8,
    maxZoom: 1.2,
    includeHiddenNodes: false,
  },
  minZoom: 0.5,
  maxZoom: 2,
  background: {
    gap: 20,
    size: 1,
  },
}
